import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, message, Table, Typography, Space, Image, Tag, Tabs, Popover } from 'antd';
import useDocumentPageHook from '../DocumentPage/DocumentPageHook';
import NewTaskPopover from './NewTaskPopover';
import './LeadsPage.css';  // Assume we are using a CSS file for styles

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const MyLeadsPage = () => {
  const { getSystemSessions, initiateSystemTask, pollSystemTasks } = useDocumentPageHook();
  const [sessions, setSessions] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();

  const fetchSessions = async () => {
    const data = await getSystemSessions();
    if (data) {
      console.log(data)
      setSessions(data);
      setIsProcessing(data?.url_details?.some(detail => detail.state === 1));

    } else {
      message.error('Failed to load sessions. Try again later');
    }
  };

  useEffect(() => {
    fetchSessions();
  }, []);

  const columns = [
    {
      title: 'Session Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'URLs to Analyze',
      dataIndex: 'url_details',
      key: 'url_count',
      render: (_, record) => record.urls_to_analyze,
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      render: (_, record) => (
        <Tag color={record.is_complete ? 'green' : 'yellow'}>
          {record.is_complete ? 'Complete' : 'Running'}
        </Tag>
      ),
    },  
    {
      title: 'Date',
      dataIndex: 'upload_date',
      key: 'upload_date',
      render: date => new Date(date).toLocaleString()
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button onClick={() => navigate(`/leads/tasks/${record.session_id}`, { state: { session: record } })}>
          View Details
        </Button>
      )
    }
  ];
  const handleInitiateTask = async (urlCount) => {
    const session_id = await initiateSystemTask(urlCount);
    fetchSessions();
    if (session_id) {
      pollSystemTasks(session_id);
    } else {
      message.error('Failed to initate tasks. Try again later');
    }
  };

  

  return (
    <div className="my-leads-page">
      <div className="upload-section">
        <div className="upload-content">
          <img src="/upload_icon.png" alt="Upload icon" className="upload-icon" />
          <div className="upload-text">
            <h3>Initiate Lead Analysis</h3>
            <p>Initiate the lead analysis. and Dealight will find you qualified leads based on your campaign setup.</p>
          </div>
        </div>
        <NewTaskPopover onInitiateTask={handleInitiateTask} maxURLCount={10} isProcessing={isProcessing} /> {/* Pass isProcessing prop */}
      </div>

      <div className="gen-content-section">
        <Table
          columns={columns}
          dataSource={sessions}
          rowKey="session_id"
          pagination={false}
        />        
      </div>
    </div>
  );
};

export default MyLeadsPage;



